<template>
  <div class="driver-dispatch-info">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5" v-if="companyType === '1'">
            <el-form-item label="分公司:">
              <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                <el-option
                  v-for="item in belongCompanyData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="所属服务商:">
              <el-select style="width: 100%" clearable v-model="searchForm.companyId" placeholder="请选择">
                <el-option
                  v-for="item in companyList"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--          <el-col :span="5">-->
          <!--            <el-form-item label="运单数量:">-->
          <!--              <el-input style="width: 100%" v-model="searchForm.roleId" placeholder="请输入"></el-input>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->

          <el-col :span="5">
            <el-form-item label="司机姓名/电话:">
              <el-input style="width: 100%" v-model="searchForm.keyword" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="车辆号码:">
              <el-input style="width: 100%" v-model="searchForm.carNumber" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="">
              <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:todayCarrierNum="{ row }">
          <span v-if="row.todayCarrierNum >= 0" @click="checkOrder(row)" style="cursor: pointer" class="color526bec">{{row.todayCarrierNum}}</span>
          <span class="color526bec" v-else>-</span>
        </template>
        <template v-slot:startCityName="{ row }">{{row.startCityName}}-{{row.endCityName}}</template>
      </custom-table>
    </div>
    <todayOrderDetail ref="todayOrderDetail"></todayOrderDetail>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import {deleteInfo, enableUser, getCarrierPage, getPage} from "../api";
import tableMixin from "@/mixin/tableMixin";
import { getRoleSelect } from "@/views/commonApi";
import todayOrderDetail from "./todayOrderDetail.vue";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import { getSelectCompany } from "@/views/SystemManagement/CompanyManagement/api";
import { getSelectSupplier } from "@/views/SystemManagement/ServiceManagement/api";
export default {
  name: "Staff-management",
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    OperateBox,
    todayOrderDetail,
    CustomTable,
  },
  data() {
    return {
      getTableMethod: getCarrierPage,
      isImmediatelyGetData: true,
      haveBelongCompany: true,
      searchForm: {
        "belongCompanyId": "",
        "carNumber": "",
        "companyId": "",
        "keyword": ""
      },
      companyList: [],
      tableColumn: [
        {
          label: "司机姓名",
          prop: "username",
          show: true,
        },

        {
          label: "手机号码",
          prop: "phone",
          show: true,
        },
        {
          label: "所属机构",
          prop: "companyName",
          show: true,
        },
        {
          label: "车牌号码",
          prop: "carNumber",
          show: true,
        },
        {
          label: "运输线路",
          prop: "startCityName",
          scopeStatus: true,
          show: true,
        },
        {
          label: "车队长",
          prop: "vehicleLeaderName",
          show: true,
        },
        {
          label: "派单调度",
          prop: "dispatcherName",
          show: true,
        },
        {
          label: "可装容量",
          prop: "marginVolume",
          show: true,
        },
        {
          label: "可装重量",
          prop: "marginWeight",
          show: true,
        },
        {
          label: "今日承运订单",
          prop: "todayCarrierNum",
          scopeStatus: true,
          show: true,
        },
        {
          label: "更新时间",
          prop: "marginTime",
          show: true,
        },
      ],
    };
  },
  watch: {
    "searchForm.belongCompanyId":function(val) {
      this.searchForm.companyId = "";
      this.getSelectSupplierData(val)
    }
  },
  created() {},
  mounted() {
    // this.getSelectCompany()
  },
  methods: {
    checkOrder(row) {
      this.$refs.todayOrderDetail.init(row.driverId, row.username);
    },
    // 获取公司
    // getSelectCompany() {
    //   getSelectCompany().then((res) => {
    //     if (res.code === 200) {
    //       this.companyList = res.data;
    //     }
    //   });
    // },
    getSelectSupplierData(val) {
      getSelectSupplier({
        belongCompanyId: val,
        keyword: '',
      }).then(response => {
        if (response.code === 200) {
          this.companyList = response.data
        }
      })
    },
    handleReset() {
      this.searchForm.belongCompanyId = this.belongCompanyId;
      this.searchForm.keyword = "";
      this.searchForm.carNumber = "";
      this.searchForm.companyId = "";
      this.tableOptions.currentPage = 1;
      this.searchPage();
    },
  },
};
</script>
<style lang="scss" scoped>
.driver-dispatch-info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }
  .custom-table-box {
    //padding-bottom: 0.68rem;
    padding-top: 0;
  }
  .statistics-box {
    display: flex;
    justify-content: space-around;
    padding: 0 0.16rem;
    margin: 0 -0.1rem;
    .statistics-list {
      width: 33.33%;
      height: 1.2rem;
      background-color: #fbfcff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.2rem;
      box-sizing: border-box;
      margin: 0 0.1rem;
      .statistics-image {
        width: 0.8rem;
        height: 0.61rem;
      }
      .statistics-num {
        .num {
          font-size: 0.24rem;
          color: #000000;
          font-weight: bold;
        }
        .txt {
          font-size: 0.14rem;
          color: #434343;
          padding-top: 0.1rem;
        }
      }
    }
  }
  .tab-check-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem;
    box-sizing: border-box;
  }
}
</style>
